document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[id^="child-product-picker-"]');

  sections.forEach((section) => {
    const sectionId = section.dataset.section;
    const wrapper = document.getElementById(`ChildProductVariantsWrapper-${sectionId}`);
    const dataElement = document.getElementById(`ChildProductsData-${sectionId}`);
    const pickerType = wrapper?.dataset.pickertype || 'dropdown';

    const fixedBar = document.getElementById(`fixed-add-to-cart-bar-${sectionId}`);
    const fixedForm = document.getElementById(`fixed-atc-form-${sectionId}`);
    const fixedVariantInput = document.getElementById(`fixed-variant-id-${sectionId}`);
    const priceEl = document.getElementById(`fixed-atc-price-${sectionId}`);
    const childNameEl = document.getElementById(`fixed-atc-child-name-${sectionId}`);
    const noteEl = document.getElementById(`meal-note-bar-${sectionId}`);
    const mainForm = document.getElementById(`MealPlanForm-${sectionId}`);

    if (!wrapper || !dataElement || !fixedBar || !fixedForm || !fixedVariantInput || !mainForm) return;

    const childProducts = JSON.parse(dataElement.textContent);

    let cartVariantIds = new Set();
    let currentChildProduct = null;
    let currentVariant = null;
    let currentSelections = {
      option1: '',
      option2: '',
      option3: ''
    };

    function unique(values) {
      return [...new Set(values.filter(Boolean))];
    }

    function getSelectedChildTitle() {
      const dropdown = section.querySelector('.child-product-select');
      if (dropdown) return dropdown.value;

      const checked = section.querySelector('.child-product-radio:checked');
      return checked ? checked.value : null;
    }

    function getChildProductByTitle(title) {
      return childProducts.find((product) => product.title === title) || null;
    }

    function getWorkingVariants(product) {
      const availableVariants = product.variants.filter((variant) => variant.available);
      return availableVariants.length ? availableVariants : product.variants;
    }

    function getFirstUsableVariant(product) {
      const variants = getWorkingVariants(product);
      return variants[0] || null;
    }

    function getOption1Values(product) {
      return unique(getWorkingVariants(product).map((variant) => variant.option1));
    }

    function getOption2Values(product, option1) {
      return unique(
        getWorkingVariants(product)
          .filter((variant) => variant.option1 === option1)
          .map((variant) => variant.option2)
      );
    }

    function getOption3Values(product, option1, option2) {
      return unique(
        getWorkingVariants(product)
          .filter((variant) => variant.option1 === option1 && variant.option2 === option2)
          .map((variant) => variant.option3)
      );
    }

    function findMatchingVariant(product, selections) {
      return (
        getWorkingVariants(product).find((variant) => {
          return (
            variant.option1 === selections.option1 &&
            variant.option2 === selections.option2 &&
            ((variant.option3 || '') === (selections.option3 || ''))
          );
        }) || null
      );
    }

    function normalizeSelections(product) {
      const firstVariant = getFirstUsableVariant(product);

      if (!firstVariant) {
        currentSelections = { option1: '', option2: '', option3: '' };
        return;
      }

      const option1Values = getOption1Values(product);
      if (!option1Values.includes(currentSelections.option1)) {
        currentSelections.option1 = firstVariant.option1 || option1Values[0] || '';
      }

      const option2Values = getOption2Values(product, currentSelections.option1);
      if (!option2Values.includes(currentSelections.option2)) {
        currentSelections.option2 = firstVariant.option2 || option2Values[0] || '';
      }

      const option3Values = getOption3Values(product, currentSelections.option1, currentSelections.option2);
      if (option3Values.length) {
        if (!option3Values.includes(currentSelections.option3)) {
          currentSelections.option3 = firstVariant.option3 || option3Values[0] || '';
        }
      } else {
        currentSelections.option3 = '';
      }
    }

    function renderFieldset(name, label, values, selectedValue) {
      if (!values.length) return '';

      let html = `<fieldset class="product-form__input product-form__input--${pickerType === 'button' ? 'pill' : 'dropdown'}">`;
      html += `<legend class="form__label">${label}</legend>`;

      if (pickerType === 'button') {
        values.forEach((value, index) => {
          const id = `${sectionId}-${name}-${index}`;
          const checked = value === selectedValue ? 'checked' : '';
          html += `
            <input
              type="radio"
              id="${id}"
              name="${name}"
              value="${value}"
              class="variant-radio visually-hidden"
              ${checked}
            >
            <label for="${id}" class="variant-pill">${value}</label>
          `;
        });
      } else {
        html += `<div class="select"><select name="${name}" class="variant-dropdown select__select">`;
        values.forEach((value) => {
          const selected = value === selectedValue ? 'selected' : '';
          html += `<option value="${value}" ${selected}>${value}</option>`;
        });
        html += `</select></div>`;
      }

      html += `</fieldset>`;
      return html;
    }

    function isSameVariantAlreadyInCart() {
      return currentVariant ? cartVariantIds.has(Number(currentVariant.id)) : false;
    }

    function updateFixedATCBar() {
      const submitBtn = fixedForm.querySelector('button[type="submit"]');

      if (!currentVariant) {
        fixedBar.classList.add('hidden');
        return;
      }

      fixedVariantInput.value = currentVariant.id;

      if (priceEl) {
        priceEl.textContent = `AED ${(currentVariant.price / 100).toFixed(2)}`;
      }

      if (childNameEl && currentChildProduct?.title) {
        childNameEl.textContent = currentChildProduct.title;
      }

      fixedBar.classList.remove('hidden');

      if (isSameVariantAlreadyInCart()) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
        noteEl.textContent = 'This same variant is already in your cart.';
        noteEl.style.display = 'block';
      } else {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-disabled');
        noteEl.style.display = 'none';
      }
    }

    function renderCurrentProductOptions() {
      if (!currentChildProduct) return;

      normalizeSelections(currentChildProduct);

      const optionNames = currentChildProduct.options || [];
      const option1Label = optionNames[0] || 'Calories';
      const option2Label = optionNames[1] || 'Weeks';
      const option3Label = optionNames[2] || 'Days';

      const option1Values = getOption1Values(currentChildProduct);
      const option2Values = getOption2Values(currentChildProduct, currentSelections.option1);
      const option3Values = getOption3Values(
        currentChildProduct,
        currentSelections.option1,
        currentSelections.option2
      );

      let html = '';
      html += renderFieldset('option1', option1Label, option1Values, currentSelections.option1);
      html += renderFieldset('option2', option2Label, option2Values, currentSelections.option2);

      if (option3Values.length) {
        html += renderFieldset('option3', option3Label, option3Values, currentSelections.option3);
      }

      wrapper.innerHTML = html;
      currentVariant = findMatchingVariant(currentChildProduct, currentSelections);
      updateFixedATCBar();
    }

    function setCurrentProduct(product) {
      currentChildProduct = product;
      const firstVariant = getFirstUsableVariant(product);

      currentSelections = {
        option1: firstVariant?.option1 || '',
        option2: firstVariant?.option2 || '',
        option3: firstVariant?.option3 || ''
      };

      renderCurrentProductOptions();
    }

    async function loadCartVariantIds() {
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: { Accept: 'application/json' }
      });
      const cart = await response.json();
      cartVariantIds = new Set(cart.items.map((item) => Number(item.variant_id)));
    }

    function replaceSectionHtml(sectionKey, targetId, sectionsHtml) {
      if (!sectionsHtml || !sectionsHtml[sectionKey]) return;

      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionsHtml[sectionKey], 'text/html');
      const newNode = doc.getElementById(targetId);
      const oldNode = document.getElementById(targetId);

      if (newNode && oldNode) {
        oldNode.replaceWith(newNode);
      }
    }

    async function addCurrentVariantToCart() {
      if (!currentVariant) return;
      if (!mainForm.reportValidity()) return;

      if (isSameVariantAlreadyInCart()) {
        noteEl.textContent = 'This same variant is already in your cart.';
        noteEl.style.display = 'block';
        return;
      }

      const submitBtn = fixedForm.querySelector('button[type="submit"]');
      const cartDrawer = document.querySelector('cart-drawer');

      try {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-disabled', 'true');
        noteEl.style.display = 'none';

        const formData = new FormData();
        formData.append('id', currentVariant.id);

        mainForm.querySelectorAll('[name^="properties["]').forEach((field) => {
          formData.append(field.name, field.value);
        });

        if (cartDrawer) {
          formData.append(
            'sections',
            cartDrawer.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof cartDrawer.setActiveElement === 'function') {
            cartDrawer.setActiveElement(document.activeElement);
          }
        }

        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
          },
          body: formData,
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || 'Unable to add product.');
        }

        cartVariantIds.add(Number(currentVariant.id));

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(data);
        } else {
          window.location.href = window.routes.cart_url || '/cart';
          return;
        }

        updateFixedATCBar();
      } catch (error) {
        console.error(error);
        noteEl.textContent = error.message || 'Unable to add product.';
        noteEl.style.display = 'block';
      } finally {
        submitBtn.disabled = false;
        submitBtn.removeAttribute('aria-disabled');

        if (cartDrawer) {
          cartDrawer.classList.remove('is-empty');
        }
      }
    }

    section.addEventListener('change', function (event) {
      const target = event.target;

      if (target.matches('.child-product-select, .child-product-radio')) {
        const selectedTitle = getSelectedChildTitle();
        const selectedProduct = getChildProductByTitle(selectedTitle);

        if (selectedProduct) {
          setCurrentProduct(selectedProduct);
        }
      }
    });

    wrapper.addEventListener('change', function (event) {
      const target = event.target;

      if (!currentChildProduct) return;

      if (target.name === 'option1') {
        currentSelections.option1 = target.value;
        currentSelections.option2 = '';
        currentSelections.option3 = '';
        renderCurrentProductOptions();
        return;
      }

      if (target.name === 'option2') {
        currentSelections.option2 = target.value;
        currentSelections.option3 = '';
        renderCurrentProductOptions();
        return;
      }

      if (target.name === 'option3') {
        currentSelections.option3 = target.value;
        currentVariant = findMatchingVariant(currentChildProduct, currentSelections);
        updateFixedATCBar();
      }
    });

    fixedForm.addEventListener('submit', function (event) {
      event.preventDefault();
      addCurrentVariantToCart();
    });

    loadCartVariantIds().then(() => {
      const initialTitle = getSelectedChildTitle();
      const initialProduct = getChildProductByTitle(initialTitle) || childProducts[0];

      if (initialProduct) {
        setCurrentProduct(initialProduct);
      }
    });
  });
});